import {
  MockMap,
} from '@ama-sdk/core';
import {
  ErrorMessage,
} from '@dapi/sdk';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  journeys,
} from '../../mock/data';

const refinementError: ErrorMessage = {
  code: '1010',
  title: 'Option request name to be provided for filtering',
  type: 'error',
  id: '1010'
};

const noBookingFoundError: ErrorMessage = {
  code: '2019',
  title: 'No matching bookings found',
  type: 'error',
  id: '2019'
};

/**
 * OW Journey
 * Group PNR
 * Filter using First Name
 */
export const ow1JourneyFirstNameFilteringGroupPax: MockMap = {

  retrieveJourneys: [
    createMockData(undefined, [refinementError]),
    createMockData(undefined, [noBookingFoundError]),
    createMockData(undefined, [refinementError]),
    createMockData(journeys),
    createMockData(undefined, [refinementError]),
    createMockData(undefined, [noBookingFoundError]),
    createMockData(journeys)
  ]
};
